// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"c3b57302","977":"8ea13d5b"}[chunkId] + ".chunk.js";
};